import Input from "components/form-elements/Input";
import Button from "components/form-elements/buttons/Button";
import ReactSelect from "components/form-elements/select/ReactSelect";
import { useRequest } from "hooks/useRequest";
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
//import { toast } from "react-toastify";
import CountryList from 'country-list-with-dial-code-and-flag'
import CountryFlagSvg from 'country-list-with-dial-code-and-flag/dist/flag-svg'
import { stages } from "utils/Constants";
import LoaderTwo from "pages/LoaderTwo";
import Loader from "pages/Loader";
import useTranslate from "hooks/useTranslate";
import {updateUserChoises} from "redux/features/general/generalSlice";


const StageAddresses = ({setRegisterState}) => {
    const [request,loading] = useRequest();
    const { currentLocation, updateAddress } = useSelector(state => state.general)
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [neighbourhoods, setNeighbourhoods] = useState([]);
    const [isStreetFocus, setIsStreetFocus] = useState(false)
    const streetWrapperRef = useRef(null)
    const {t} = useTranslate()
    const dispatch = useDispatch()
    //const [streets, setStreets] = useState([]);
    //const [buildings, setBuildings] = useState([]);
  
    const [addressInfo, setAddressInfo] = useState({
        firstName: "",
        lastName: "",
        addressTitle: "",
        province: "",
        provinceId: null,
        district: "",
        districtId: null,
        neighbourhood: "",
        neighbourhoodId: null,
        street: "",
        streetId: null,
        building: "",
        buildingId: null,
        floor: "",
        apartment: "",
        addressDescription: "",
        latitude: null,
        longitude: null,
        countryCode:"",
        phone: ""
      })

      const [streetResults, setStreetResults] = useState([]);
      const [timer, setTimer] = useState(null)
      useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
          if (streetWrapperRef.current && !streetWrapperRef.current.contains(event.target)) {
              setIsStreetFocus(false)
          }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [streetWrapperRef]);
      useEffect(() => {
        if ( !addressInfo.firstName ) {
         request('/Profile', {
           method: 'GET',
         }).then(res => {
           if (res.data.ok) {
             const profileInfo = res.data.result
             const defaultCountry = countries.find(ct => ct.value == '+' + profileInfo?.countryCode?.toString())
             setAddressInfo(prev => ({
               ...prev,
               firstName: profileInfo?.firstName,
               lastName: profileInfo?.lastName,
               phone:profileInfo?.phone,
               countryCode:defaultCountry
             }))
           }
         })
        }
       },[])
       
    const countries = [
        ...CountryList.getAll().map(ct => ({ label: ct.data.dial_code, value: ct.data.dial_code, image: CountryFlagSvg[ct.data.code] }))
      ];


      useEffect(() => {

        if (updateAddress) {
          setAddressInfo(prev => ({
            ...prev,
            ...updateAddress
          }))
        }
      }, [updateAddress])
    
      useEffect(() => {
        if (currentLocation) {
          setAddressInfo(prev => ({
            ...prev,
            ...currentLocation
          }))
        }
      }, [currentLocation])
    
      useEffect(() => {
        request('/Location/Provinces', {
          method: 'GET',
        }).then((res) => {
          if (res) {
            //setAddressInfo({...addressInfo, })
            setProvinces(res?.data?.result?.map(province => ({ value: province.name, label: province.name, id: province.provinceId })))
            if (addressInfo?.provinceId) {
              request(`/Location/Districts/${addressInfo?.provinceId}`, {
                method: "GET"
              })
                .then((res) => {
                  setDistricts(res?.data?.result?.map(district => ({ value: district.name, label: district.name, id: district.districtId })))
                  if (addressInfo?.districtId) {
                    request(`/Location/Neighbourhoods/${addressInfo?.districtId}`, {
                      method: "GET"
                    })
                      .then((res) => {
                        setNeighbourhoods(res?.data?.result?.map(neighbourhood => ({ value: neighbourhood.name, label: neighbourhood.name, id: neighbourhood.neighbourhoodId, districtId: neighbourhood.districtId, latY: neighbourhood.latY, longX: neighbourhood.longX })))
                        // if (addressInfo?.neighbourhoodId) {
                        //   request(`/Location/Streets/${addressInfo?.neighbourhoodId}`, {
                        //     method: "GET"
                        //   })
                        //     .then((res) => {
                        //       setStreets(res?.data?.result?.map(street => ({ value: street.name, label: street.name, id: street.ilcsId })))
                        //       if (addressInfo?.streetId) {
                        //         request(`/Location/Buildings/${addressInfo?.streetId}`, {
                        //           method: "GET"
                        //         })
                        //           .then((res) => {
                        //             setBuildings(res.data.result)
                        //           })
                        //       }
                        //     })
                        // }
                        
                      })
                  }
                })
            }
    
          }
        })
      }, [addressInfo?.provinceId, addressInfo?.districtId, addressInfo?.neighbourhoodId, addressInfo?.streetId])
    

      const handleChange = (e, name, id) => {
        if (name && id) {
          setAddressInfo({ ...addressInfo, [name]: e?.value, [id]: e?.id,latitude:undefined, longitude:undefined,streetId: undefined, street:'' })
        } else if (name) {
          setAddressInfo({ ...addressInfo, [name]: e?.value })
        } else {
          setAddressInfo({ ...addressInfo, [e.target.name]: e?.target.value })
        }
      }
    
      const addAdress = () => {
        let sendAddressInfo = Object.keys(addressInfo)
          .filter((a) => !a.includes("undefined"))
          .reduce((obj, key) => {
            obj[key] = addressInfo[key]
            return obj
          }, {})

        setTimeout(() => {
          request('Profile/UpsertAddress', {
            method: "POST",
            data: {...sendAddressInfo, countryCode: addressInfo.countryCode.value.slice(1)}
          })
            .then(res => {
              if (res && res.data.ok) {
                if (!sendAddressInfo.id) {
                  //navigate(`/branch-address/${res?.data?.result?.id}`, { replace: true, state: "Adres" })
                  dispatch(updateUserChoises({addressId : res?.data?.result?.id, text: "Adres", neighbourhoodId: addressInfo?.neighbourhoodId}))
                  setRegisterState(stages.STAGE_BRANCH)
                  //auth.setUserChoises({addressId : res?.data?.result?.id, text: "Adres"})
                } 
                // else {
                //   toast.success('Adres Güncelleme İşlemi Başarılı')
                // }
              }
            })
        }, 300);
      }


      const handleStreetChange = (e) => { 
        let val = e.target.value; 


        setAddressInfo(prev => ({
          ...prev,
          latitude: undefined,
          longitude: undefined,
          streetId:undefined,
          street: val
        }))

        clearTimeout(timer)

        const newTimer = setTimeout(() => {
          if (addressInfo?.neighbourhoodId && val.length >= 3) {
            request(`/Location/SearchAddress`, {
            method: "POST",
            data: {
              search : val,
              province: addressInfo?.province,
              district: addressInfo?.district,
              neighbourhood: addressInfo?.neighbourhood
            }
       })
       .then((res) => {
        if(res){
          setStreetResults(res?.data?.result)
        }
       })
    } else if (addressInfo?.neighbourhoodId && val.length < 3) {
      setStreetResults([])
    }
        }, 1000)
    
        setTimer(newTimer)

        
      }

      const autoCompleteChoice = (street) => {
        setAddressInfo(prev => ({
          ...prev,
          ...street,
          neighbourhood: prev.neighbourhood,
          street: street?.address
        }))
        setStreetResults([])
        setIsStreetFocus(false)
      }

      useEffect(() => {
        if (!addressInfo.countryCode) {
          const defaultCountry = countries.find(ct => ct.value == "+90")
          setAddressInfo({ ...addressInfo, countryCode: defaultCountry })
        }
    
      }, [addressInfo.countryCode])
    return (
        <div className='stageAddresses'>
          <LoaderTwo isDataLoading={loading} />
        <div className='stageAddresses-container'>

        <h1 className='stageAddresses-title'>{t('addAddress')}</h1>
        <div className='stageAddresses-subtitle'>{t('pleaseDeliveryAddress')}</div>
        {/* <Button className='btn-primary-outline btn-pinmap' onClick={() => dispatch(setPinMapModal({ open: true }))} icon={images.pinMap} text='Haritadan Ekle' /> */}
        <div className='register-container-flexInput'>
          <Input
            value={addressInfo?.firstName ? addressInfo?.firstName : ""}
            onChange={handleChange}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelName')}
            type={'text'}
            textLabel={t('labelName')}
            label={t('labelName')}
            name={"firstName"}
            required
          />
          <Input
            value={addressInfo?.lastName ? addressInfo?.lastName : ""}
            onChange={handleChange}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelSurame')}
            type={'text'}
            textLabel={t('labelSurame')}
            label={t('labelSurame')}
            name={"lastName"}
            required
          />
        </div>
        <div className='register-container-flexInput'>
          <ReactSelect
            handleChange={(d) => handleChange({ target: { name: 'countryCode', value: d } })} 
            //value={addressInfo?.countryCode}
            //defaultValue={[{ value: addressInfo?.countryCode, label: addressInfo?.countryCode, image: "" }]} 
            value={addressInfo?.countryCode}
            labelText={t('labelCountry')}
            className={"countrySelect"}
            placeholder={t('labelCountry')}
            options={countries}
            name={"countryCode"}
            isSearchable
          //id={"countryCode"}
          />
          <Input
            value={addressInfo?.phone ? addressInfo?.phone : ""}
            onChange={handleChange}
            name={"phone"}
            containerClassName={"inputPhoneClassNameContainer"}
            className={''} labelClassName={'stageTwoLabel'}
            placeholder={t('labelPhone')}
            type={'number'}
            maxLength={10}
            textLabel={t('labelPhone')}
            label={t('labelPhone')}
            required
             />
        </div>
        <hr />
        <div className='addressAddDrawer-fullWidth mt-4'>
          <ReactSelect
            labelText={t('labelProvince')}
            handleChange={e => handleChange(e, "province", "provinceId")}
            value={addressInfo?.provinceId && { value: addressInfo?.province, label: addressInfo?.province, id: addressInfo?.provinceId }}
            name={"province"}
            className={"countrySelect"}
            placeholder={t('choosePlaceholder')}
            options={provinces}
            isSearchable
            required
          />
        </div>
        <div className='addressAddDrawer-fullWidth mt-4'>
          <ReactSelect
            labelText={t('labelDistrict')}
            className={"countrySelect"}
            placeholder={t('choosePlaceholder')}
            handleChange={e => handleChange(e, "district", "districtId")}
            value={addressInfo?.districtId && { value: addressInfo?.district, label: addressInfo?.district, id: addressInfo?.districtId }}
            options={districts}
            isSearchable
            required
          />
        </div>
        <div className='addressAddDrawer-fullWidth mt-4'>
          <ReactSelect
            handleChange={e => handleChange(e, "neighbourhood", "neighbourhoodId")}
            value={addressInfo?.neighbourhoodId && { value: addressInfo?.neighbourhood, label: addressInfo?.neighbourhood, id: addressInfo.neighbourhoodId }}
            options={neighbourhoods}
            labelText={t('labelNeighbourhood')}
            className={"countrySelect"}
            placeholder={t('choosePlaceholder')}
            isSearchable
            required
          />
        </div>
        <div ref={streetWrapperRef} className='addressAddDrawer-fullWidth mt-4 mb-4 addressAddDrawer-resultStreet'>
        <Input
            value={addressInfo?.street ? addressInfo?.street : ""}
            onChange={handleStreetChange}
            name={"street"}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelStreet')}
            type={'text'}
            textLabel={t('labelStreet')} 
            label={t('labelStreet')}
            required
            onFocus={() => setIsStreetFocus(true)}
            />
            {
              isStreetFocus && <div className="addressAddDrawer-resultStreet-list" style={{top:75}}>
              {
                streetResults.length > 0 ? streetResults?.map((street,i) => (
                 <div key={i} onClick={() => autoCompleteChoice(street)} className="addressAddDrawer-resultStreet-list-item">
                     {street?.address}
                 </div> 
               )) : <div className="addressAddDrawer-resultStreet-list-item">
                 {addressInfo?.street?.length > 2 && !loading ? t('resultNotFound') : loading && <Loader isDataLoading={loading} />}
                 {addressInfo?.street?.length < 3 && t('minimumCharacter')}
             </div>
              }
           </div>
            }
        </div>

        <div className='addressAddDrawer-fullWidth mt-4 mb-4'>
          {/* <ReactSelect
            handleChange={e => handleChange(e, "building", "buildingId", "latitude", "longitude")}
            value={[{ value: addressInfo?.building, label: addressInfo?.building }]}
            //options={buildings.map(building => ({ value: building.no, label: building.no, id: building.id, geo: building?.geo }))}
            options={""}
            labelText={"Bina No"}
            className={"countrySelect"}
            placeholder={"Seçiniz"}
            isSearchable
          /> */}
          <Input
            value={addressInfo?.building ? addressInfo?.building : ""}
            onChange={handleChange}
            name={"building"}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelBuildNo')}
            type={'text'}
            textLabel={t('labelBuildNo')} 
            label={t('labelBuildNo')}    
            />
        </div>     
        <div className='register-container-flexInput'>
          <Input
            value={addressInfo?.floor ? addressInfo?.floor : ""}
            onChange={handleChange}
            name={"floor"}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelFloor')}
            type={'text'}
            textLabel={t('labelFloor')} 
            label={t('labelFloor')}    
            />
          <Input
            value={addressInfo?.apartment ? addressInfo?.apartment : ""}
            onChange={handleChange}
            name={"apartment"}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelAparmentNo')}
            type={'text'}
            textLabel={t('labelAparmentNo')} 
            label={t('labelAparmentNo')}  
            />
        </div>
        <Input
          value={addressInfo?.addressDescription ? addressInfo?.addressDescription : ""}
          onChange={handleChange}
          name={"addressDescription"}
          containerClassName={""}
          className={''}
          labelClassName={'stageTwoLabel'}
          placeholder={t('labelForDirections')}
          type={'text'}
          textLabel={t('labelForDirections')} 
          label={t('labelForDirections')} 
          />
        {/* <hr /> */}
        <div className='addressAddDrawer-mt'>
          <Input
            value={addressInfo?.addressTitle ? addressInfo?.addressTitle : ""}
            onChange={handleChange}
            name={"addressTitle"}
            containerClassName={""}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelAddressName')}
            type={'text'}
            textLabel={t('labelAddressName')} 
            label={t('labelAddressName')} 
            required
            />
        </div>
        <Button onClick={addAdress} className={"claretredRoundedBtn"} icon={''} text={t('ContinueWithThisAddress')} />
      </div>
      </div>
    )
}

export default StageAddresses